import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Transactions extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Transactions";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      request_id: null,
      type: 'SALE', // SALE, AUTHORIZE, REFUND, ADJUSTMENT, VOID, CANCEL,
      app: null, // SUBSCRIPTION, TERMINAL, , FORM, DONATION, INSTALLMENT,
      method: null, // KEYED, TOKEN, 
      payment_type: null, // CREDITCARD, ACH, CASH, CHECK, GIFTCARD
      status: "PENDING",
      details: {
        description: null,
        memo: null,
        order_id: null,
        invoice_id: null,
        po_id: null,
      },
      amounts: {
        total: 0,
        process: 0,
        balance: 0,
        paid: 0,
        discounts: 0,
        gratuity: 0,
        fees: 0,
        shipping: 0,
        taxes: 0,
        items_sold: 0,
      },
      processed: 0,
      payment_method: {},
      cart: null,
      customer: null,
      card: null,
      token: null,
      ach: null,
      process_amount: 0,
      currency: "USD",
      notes: [],
      tags: [],
      meta_data: {},
      three_ds: {},
      id_transaction: null,

      customer_id: null,
      cart_id: null,
      recurring_id: null,
      subscription_id: null,
      schedule_id: null,
      invoice_id: null,
      donation_id: null,
      installment_id: null,
      contract_id: null,
      form_id: null,
      terms: null,
      terms_accepted_at: null,
      ip_address: store.state.config.ip_address,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      mid_id: store.state.ids.mid_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    if (data.schedule) {
      data.schedule = new models.api.Schedules(data.schedule);
    }
    if (data.invoice) {
      data.invoice = new models.api.Invoices(data.invoice);
    }
    if (data.recurring_plan) {
      data.recurring_plan = new models.api.RecurringTemplates(data.recurring_plan);
    }
    if (data.card_token) {
      data.card_token = new models.api.VaultCards(data.card_token);
    }
    if (data.ach_token) {
      data.ach_token = new models.api.VaultBanks(data.ach_token);
    }
    if (data.customer) {
      data.customer = new models.api.Customers(data.customer);
    }
    if (data.contact) {
      data.contact = new models.api.Contacts(data.contact);
    }
    if (data.company) {
      data.company = new models.api.Companies(data.company);
    }

    return data;
  }
}
